<template>
  <div class="grid-product-tracking">
    <div v-for="tracking in trackings" :key="tracking.trackingNumber" class="row">
      <span>
        {{ `${$t('viewOrder.tracking_quantity')}: ${getQuantity(tracking)}` }}
      </span>
      <button
        v-if="isURL(tracking.trackingURL)"
        class="tracking-button"
        v-on:click="followUrl(tracking.trackingURL)"></button>
      <span>
        {{ formatTrackingNumber(tracking.trackingNumber) }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { utilsMixins } from '@/mixins/utils.mixins';
import { PackingSlipTrackingInformationModel } from '@/models/order-packing-slip-tracking-information.model';

export default defineComponent({
  name: 'grid-product-tracking',
  props: {
    params: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      trackings: new Array<PackingSlipTrackingInformationModel>(),
    };
  },
  beforeMount() {
    this.trackings = this.params?.data?.packingSlips;
  },
  methods: {
    ...utilsMixins,
    getQuantity(trackingSlip: PackingSlipTrackingInformationModel): string | undefined {
      return trackingSlip.trackingInformation?.find(
        (info) => info.inventoryTransactionNumber === this.params.data.inventoryTransactionNumber,
      )?.quantity;
    },
    followUrl(url: string) {
      const win = window.open(url, '_blank');

      win?.focus();
    },
    formatTrackingNumber(trackingNumber?: string) {
      if (trackingNumber?.toUpperCase().startsWith('MISSING')) {
        return this.$t('viewOrder.tracking_number_missing');
      }

      return trackingNumber?.trim();
    },
  },
});
</script>
]
<style scoped lang="scss">
.grid-product-tracking {
  height: 100%;

  &.hidden {
    height: 0;
    display: none;
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 50px;
    padding: 0 20px;
    position: relative;
    height: 100%;
    background-color: var(--primary-light-color-dark);
  }
}
</style>
